// Sorted by UTC offset by what the sun hits first
import { getAllTimezones } from 'countries-and-timezones'
import type { Timezone } from 'countries-and-timezones'
import * as Localization from 'expo-localization'

export const DEFAULT_TIMEZONE = Localization.timezone

export const SORTED_TIMEZONES = Object.values(getAllTimezones()).sort((a, b) =>
  a.utcOffset > b.utcOffset ? -1 : 1
)

export { getTimezone } from 'countries-and-timezones'

export type { Timezone }
